<template>
  <view-wrapper
    name="Print History"
    :loading="loading"
    :loadingText="loadingText"
  >
    <print-history-search-form
      :removeVariable="removeVariable"
      :variableKeys="variableKeys"
      :onSearch="onSearch"
      :addVariable="addVariable"
      :variables="variables"
      :searchText="searchText"
      @input="searchText = $event"
      :clearForm="clearForm"
      :pageSize="pageSize"
      :page="page"
      @startDate="startDate = $event"
      @endDate="endDate = $event"
      :startDate="startDate"
      :endDate="endDate"
      :serialNumber="serialNumber"
      @serialNumberInput="serialNumber = $event"
      :counters="counters"
      :counterId="counterId"
      @counterInput="counterId = $event"
    />
    <print-history-list
      :printHistory="printHistory"
      @loading="loading = $event"
      @loadingText="loadingText = $event"
      :page="page"
      :pageSize="pageSize"
      :setPage="setPage"
      :computerName="computerName"
    />
  </view-wrapper>
</template>

<script>
import PrintHistorySearchForm from "../components/printhistory/PrintHistorySearchForm.vue";
import PrintHistoryList from "../components/printhistory/PrintHistoryList.vue";
import axios from "axios";

export default {
  components: {
    PrintHistorySearchForm,
    PrintHistoryList,
  },
  computed: {
    counters() {
      return this.$store.getters["COUNTERS/COUNTERS"];
    },
  },
  data() {
    return {
      loading: false,
      loadingText: "Loading Print History",
      printHistory: [],
      page: 1,
      pageSize: 10,
      searchText: "",
      variables: [],
      variableKeys: [],
      startDate: null,
      endDate: null,
      serialNumber: null,
      counterId: null,
      computerName: null,
    };
  },
  methods: {
    async getData() {
      this.loading = true;

      const { data } = await this.$store.$api.get(
        "/api/printjobs/printjobentries",
        {
          params: {
            offset: this.pageSize * (this.page - 1),
            take: this.pageSize,
            searchText: this.searchText,
            variables: JSON.stringify(this.variables),
            startDate: this.startDate ? this.startDate.toISOString() : "",
            endDate: this.endDate ? this.endDate.toISOString() : "",
            serialNumber: this.serialNumber || undefined,          counterId: this.counterId || undefined,          },
        }
      );


      const { data: standardLabelsData } = await this.$store.$api.get(
        "/api/labels/testlabels"
      );

      this.printHistory =
        data &&
        data.data &&
        data.data.map(x => {
          // Collect all serial numbers from child entries
          const allSerialNumbers = [];
          if (x.childPrintJobEntries && x.childPrintJobEntries.length > 0) {
            x.childPrintJobEntries.forEach(child => {
              if (child.serialNumbers && child.serialNumbers.length > 0) {
                allSerialNumbers.push(...child.serialNumbers);
              }
            });
          }
          // Use serialNumbers from main object if available, otherwise use collected ones
          const serialNumbers = x.serialNumbers && x.serialNumbers.length > 0 
            ? x.serialNumbers 
            : allSerialNumbers;

          return {
            id: x.printJobEntryId,
            printJobId: x.printJobId,
            labelName: x.labelName,
            status: x.status,
            modified: x.modified,
            quantity: x.quantity,
            disabled:
              standardLabelsData &&
              standardLabelsData.data &&
              standardLabelsData.data.some(l => l.labelId === x.labelId),
            expandableData: {
              ...x,
              id: x.printJobEntryId,
              showVariables: false,
              showSerials: false,
              serialNumbers: serialNumbers, // Use collected serial numbers
            },
          };
        });

      this.loading = false;
    },
    setPage(newPage) {
      this.page = Math.max(1, newPage);
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    addVariable(data) {
      this.variables.push({
        key: data.key,
        data: null,
      });
    },
    removeVariable(index) {
      this.variables.splice(index, 1);
    },
    clearForm() {
      this.searchText = null;
      this.variables = [];
      this.startDate = null;
      this.endDate = null;
      this.serialNumber = null;
      this.counterId = null;
    },
  },
  async mounted() {
    this.loading = true;

    const { data } = await this.$store.$api.get(
      "/api/printjobs/printjobentries/variables"
    );

    this.variableKeys = data && data.data && data.data.map(x => ({ key: x }));

    if (this.$store.getters["COUNTERS/COUNTERS"].length === 0) {
      await this.$store.dispatch("COUNTERS/GET_COUNTERS");
    }

    const printerHelperUri = this.$store.getters["SETTINGS/PRINTER_HELPER_URI"];
    try {
      const { data } = await axios.get(`${printerHelperUri}/api/printQueues`);
      this.computerName = data && data.computerName;
    } catch (error) {
      this.computerName = null;
    }

    this.getData();
  },
};
</script>

<style>
.variables-header {
  @apply w-full text-xs font-bold border-white pb-1;
  border-bottom: 1px solid;
}
</style>
